import {
  Dialog,
  DialogContent,
  Typography,
  Box,
  useTheme,
} from "@mui/material";
import ButtonComp from "../../../components/Button";

interface ClaimApprovePopupProps {
  open: boolean;
  onClose: () => void;
  onApprove: any;
}
const ClaimApprovePopup = ({
  open,
  onClose,
  onApprove,
}: ClaimApprovePopupProps) => {
  const theme = useTheme();

  return (
    <Dialog
      fullWidth
      //maxWidth="sm"
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            height: 400,
            borderRadius: 4,
            overflow: "hidden",
          },
        },
      }}
    >
      <Box
        sx={{
          backgroundColor: "primary.main",
          height: 70,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      ></Box>

      <DialogContent
        sx={{
          backgroundColor: theme.palette.background.default,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          gap={4}
        >
          <Typography
            fontSize={{ xs: 30, sm: 35 }}
            fontWeight={600}
            textAlign="center"
          >
            Confirm Approval
          </Typography>
          <Typography fontSize={18} textAlign="center">
            Are you sure you want to approve this claim?
          </Typography>

          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection={{ xs: "column", sm: "row" }}
            gap={{ xs: 2, md: 6 }}
            width="100%"
          >
            <ButtonComp
              variant="contained"
              height={40}
              width={150}
              onClick={() => onApprove("Approve")}
              textTransform="none"
            >
              Approve
            </ButtonComp>
            <ButtonComp
              variant="contained"
              height={40}
              width={150}
              onClick={onClose}
              textTransform="none"
            >
              Cancel
            </ButtonComp>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ClaimApprovePopup;
